import { SvgIcon } from '@mui/material';

export default function StopSearchIcon(props: any) {
  return (
    <SvgIcon width="20" height="20" viewBox="0 0 21 21" fill="none" {...props} style={{ ...props.style }}>
      <g clip-path="url(#clip0_305_29975)">
        <path
          d="M9.45691 18.1409C14.0635 18.1409 17.7979 14.4065 17.7979 9.79987C17.7979 5.19326 14.0635 1.45886 9.45691 1.45886C4.8503 1.45886 1.11591 5.19326 1.11591 9.79987C1.11591 14.4065 4.8503 18.1409 9.45691 18.1409Z"
          stroke="#2E3744"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
        <path d="M19.8831 20.2262L15.3477 15.6908" stroke="#2E3744" stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_305_29975">
          <rect width="20" height="20" fill="white" transform="translate(0.499512 0.842529)" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
